<template>
  <CHeader :class="$style['toolbar']" :height="height" color="grey lighten-4" elevation="0">
    <v-toolbar-items :class="$style['left']">
      <slot name="left" />
    </v-toolbar-items>
    <v-spacer />
    <v-toolbar-items>
      <slot name="middleRight" />
    </v-toolbar-items>
    <v-toolbar-items :class="$style['right']">
      <slot name="right" />
    </v-toolbar-items>
  </CHeader>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 45
    },
    hasToggleIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onToggleSideMenu() {
      this.$store.commit("toolbar/toggleSideMenu");
    }
  }
};
</script>

<style module lang="scss">
.toolbar {
  z-index: 3;
  position: relative;
  border: 0 !important;
  min-height: 54px !important;
}
@media screen and (max-width: 960px){
  .left{
    margin-top: 5px
  }
  .right{
    margin: 10px
  }
}

</style>
